export function convertToBoolean(value) {

    return (value === "false") !== Boolean(value);
    // value = "true"  => result = true
    // value = "false" => result = false
    // value = true    => result = true
    // value = false   => result = false
    // value = null    => result = false
    // value = []      => result = true
    // etc..
}

export function endDateControl(endDate) {

    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    var todayShortDate = `${month}/${date}/${year}`;

    endDate = new Date(endDate);
    const endDateMonth = endDate.getMonth() + 1;
    const endDateYear = endDate.getFullYear();
    const endDateDate = endDate.getDate();
    var endDateShortDate = `${endDateMonth}/${endDateDate}/${endDateYear}`;

    if (todayShortDate == endDateShortDate) {
        return (today)
    }
    else {
        return endDate;
    }
}